import * as React from "react";
import { inject, observer } from "mobx-react";
import { AppProps } from "../../stores/storeContract";
import "./Trades.scss";
import { ITrade } from "../../stores/scannerStore";

interface AppPropsTrades extends AppProps {  
    symbol?: string;
    trades?: ITrade[];
    highlightTradeIds?: number[];
}

@inject("formatStore") // "scannerStore"
@observer
export default class TradesPreviewVerticalArrows extends React.Component<AppPropsTrades> { 

	
   render() {

        const { formatTime, formatNumber } = this.props.formatStore;
        const { formatSymbolQuote } = this.props.symbolStore;
        const { symbol, trades, highlightTradeIds } = this.props;

       
        var ignoreFirstTrades = true;
        var shouldRenderAggregateTrade = false;
        var aggregateTradeCount = 0;
        var aggregateTradeUsd = 0;

        return (
			<div className="trades">
                 <table className="table table-sm">                   
                    <tbody>
                        {
                        

                           trades.map((t, index) => {

                            if (highlightTradeIds.includes(t.id)){
                                ignoreFirstTrades = false;
                                aggregateTradeCount = 0;
                                aggregateTradeUsd = 0;

                                var isBuy = t.amount && t.amount > 0;
                              
                                return (
                                    <tr key={t.id} >
                                        <td>
                                            <div className="line-vertical"> <div className="dot"></div></div>
                                        </td>
                                        <td className="trades-text-primary">                                            
                                            {formatNumber(Math.abs(t.amount), 4)}@{formatNumber(Math.abs(t.price), 8)} ({formatNumber(t.usd, 0)} USD)
                                        </td>                                        
                                    </tr>
                                )
                            }
                            else if (!ignoreFirstTrades){
                                shouldRenderAggregateTrade = index + 1 == trades.length || highlightTradeIds.includes(trades[index + 1].id);

                                aggregateTradeCount++;
                                aggregateTradeUsd += t.usd;
                               
                                if (shouldRenderAggregateTrade){
                                    return (
                                        <tr key={t.id}>
                                            <td>
                                            <div className="line-vertical"> </div>
                                            </td>
                                            <td className="trades-text-secondary">
                                                {aggregateTradeCount} trades ({formatNumber(aggregateTradeUsd, 0)} USD)
                                            </td>
                                        </tr>
                                    )
                                }
                            }  
                        })
                    }
                    <tr key={9999999}>
                        <td>
                            <div className="arrow-down"> </div>
                        </td>
                    </tr>                  
                    </tbody>
                </table> 
			</div>
		);
	}
}